
export class BaseProviderInstanceUserModel {
  providerId: string;
  providerInstanceId: string;
  providerInstanceResourceId: string;
}
